import { render, staticRenderFns } from "./RemarksList.vue?vue&type=template&id=3c00cb98&"
import script from "./RemarksList.vue?vue&type=script&lang=js&"
export * from "./RemarksList.vue?vue&type=script&lang=js&"
import style0 from "./RemarksList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c00cb98')) {
      api.createRecord('3c00cb98', component.options)
    } else {
      api.reload('3c00cb98', component.options)
    }
    module.hot.accept("./RemarksList.vue?vue&type=template&id=3c00cb98&", function () {
      api.rerender('3c00cb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/RemarksList.vue"
export default component.exports